var typeOf = function typeOf(type) {
  return function (v) {
    return typeof v === type;
  };
};

var isFn = typeOf("function");
var isString = typeOf("string");

var toActionName = function toActionName() {
  var str = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    str[_i] = arguments[_i];
  }

  return str.filter(isString).join(" ").replace(/\ |\-|([A-Z])/g, "_$1").replace(/__/, "_").replace(/^_/, "").toUpperCase();
};

function createAction(type, mapToPayload) {
  if (mapToPayload === void 0) {
    mapToPayload = function mapToPayload(v) {
      return v;
    };
  }

  var isType = function isType(t) {
    return t === type;
  };

  var builder = function builder(payload) {
    return {
      type: type,
      payload: mapToPayload(payload)
    };
  };

  builder.case = function (mapToUpdate) {
    return {
      isType: isType,
      exec: !isFn(mapToUpdate) ? function (s, p) {
        return p;
      } : function (s, p) {
        return mapToUpdate(s, p);
      }
    };
  };

  builder.type = type;
  builder.isType = isType;
  return builder;
}

var isValidCase = function isValidCase(c) {
  return c && isFn(c.isType) && isFn(c.exec);
};

function createReducer(initialState, actionCases, _a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.breakCase,
      breakCase = _c === void 0 ? false : _c,
      _d = _b.mergeState,
      mergeState = _d === void 0 ? Object.assign : _d;

  var empty = [];
  var validCases = empty.concat(actionCases).filter(isValidCase);
  return function (state, action) {
    if (state === void 0) {
      state = initialState;
    }

    if (!action) return state;

    if (breakCase) {
      // HANDLE ONLY FIRST CASE
      for (var _i = 0, validCases_1 = validCases; _i < validCases_1.length; _i++) {
        var _a = validCases_1[_i],
            isType = _a.isType,
            exec = _a.exec;

        if (isType(action.type)) {
          return mergeState({}, state, exec(state, action.payload));
        }
      }

      return state;
    } else {
      // HANDLE ALL CASES
      return validCases.reduce(function (acc, _a) {
        var isType = _a.isType,
            exec = _a.exec;
        return isType(action.type) ? mergeState({}, acc, exec(acc, action.payload)) : acc;
      }, mergeState({}, state));
    }
  };
}

function reduxDeltaMiddleware() {
  return function (_a) {
    var dispatch = _a.dispatch,
        getState = _a.getState;
    return function (next) {
      return function (action) {
        if (isFn(action)) return action(dispatch, getState);
        return next(action);
      };
    };
  };
}

var index = reduxDeltaMiddleware();
export default index;
export { toActionName, createAction, createReducer };